import { Component, Inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import Env from '@ridango/core/env';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from '@ridango/core/lib/services/storage.service';

@Component({
    selector: 'gl-rwidget-feedback-modal',
    templateUrl: './feedback-modal.component.html',
    styleUrls: ['./feedback-modal.component.scss']
})
export class FeedbackModalComponent {
    private readonly FEEDBACK_DECLINED_KEY = 'vl-feedback-modal-declined';

    constructor(
        private translate: TranslateService,
        private modalCtrl: ModalController,
        private storageService: StorageService,
        @Inject('ENV') public env: Env
    ) {}

    get feedbackSurveyUrl(): string {
        return this.env.FEEDBACK_SURVEY_URL;
    }

    decline() {
        this.storageService.setItem(this.FEEDBACK_DECLINED_KEY, true).subscribe();
        this.modalCtrl.dismiss({ action: 'decline' }, 'dismiss');
    }

    maybeLater() {
        this.modalCtrl.dismiss({ action: 'maybe' }, 'dismiss');
    }

    participate() {
        this.storageService.setItem(this.FEEDBACK_DECLINED_KEY, true).subscribe();
        this.modalCtrl.dismiss({ action: 'participate' }, 'dismiss');
        window.open(this.feedbackSurveyUrl, '_blank', 'noopener,noreferrer');
    }
}
